import { InjectionToken } from '@angular/core';
import { Auth, GoogleAuthProvider } from 'firebase/auth';

export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');
export const GOOGLE_AUTH_PROVIDER = new InjectionToken<GoogleAuthProvider>('GOOGLE_AUTH_PROVIDER');
